import { PrivateApiClient } from './client/private-api-client';
export * from './types/motor';
export * from './types/property';
export { PrivateApiClient };
export default PrivateApiClient;
